import { render, staticRenderFns } from "./Finalizacoes.vue?vue&type=template&id=7c033e49"
import script from "./Finalizacoes.vue?vue&type=script&lang=js"
export * from "./Finalizacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports